<template>
  <z-card-modal
    class="zoox-component zoox-facial-biometry-modal"
    closable
    persistent
    width="400px"
    :opened="isOpened"
    :title="title"
    @change="onChangeModalValue"
  >
    <template #content>
      <!--@slot Slot de descrição do componente -->
      <slot name="description" />
      <div class="video-container">
        <z-camera-stream
          ref="cameraStream"
          :stream="stream"
          :loading="loading"
          :mirror="mirror"
          :width="400"
        />
      </div>
      <div class="card-actions">
        <z-btn
          class="mx-1"
          :medium="isMobile"
          :text="$t('cancel')"
          @click="onChangeModalValue(false)"
        />
        <z-btn
          primary
          class="mx-1"
          :disabled="loading"
          :medium="isMobile"
          :text="$t('image_capture')"
          @click="onCaptureImage"
        />
      </div>
    </template>
  </z-card-modal>
</template>

<script>
/**
 * @displayName Facial Biometry Modal
 */
export default {
  name: 'ZFacialBiometryModal',
  model: {
    prop: 'isOpened',
    event: 'change',
  },
  props: {
    /**
     * A stream da câmera selecionada
     */
    stream: {
      default: null,
    },
    /**
     * Flag para espelhar a imagem do stream, voltado mais para selfies
     */
    mirror: {
      type: Boolean,
      default: false,
    },
    /**
     * Flag para colocar em estado de loading
     */
    loading: {
      type: Boolean,
      default: false,
    },
    /**
     * Título do card da modal
     */
    title: {
      type: String,
      default: '',
    },
    /**
     * Descrição da modal
     */
    description: {
      type: String,
      default: '',
    },
    /**
     * Flag para indicar que a modal está aberta
     *
     * @modelName isOpened
     */
    isOpened: {
      type: Boolean,
    },
    /**
     * Flag para indicar o dispositivo é mobile
     */
    isMobile: {
      type: Boolean,
    },
  },
  methods: {
    onChangeModalValue(isOpened) {
      /**
       * Evento emitido quando o valor da modal é alterado
       *
       * @property {Boolean} isOpened - Flag para indicar se a modal está aberta
       */
      this.$emit('change', isOpened)
      if (!isOpened) {
        /**
         * Evento emitido no fechamento da modal
         */
        this.$emit('close')
      }
    },
    async onCaptureImage() {
      const image = await this.$refs.cameraStream.getImage()

      /**
       * Evento emitido quando a imagem é capturada
       *
       * @property {String} image - Imagem capturada
       */
      this.$emit('click:capture', image)
    },
  },
  i18n: {
    messages: {
      pt: {
        cancel: 'Cancelar',
        image_capture: 'Capurar imagem',
      },
      en: {},
      es: {},
      fr: {
        cancel: 'Annuler',
        image_capture: "Capture d'image",
      },
      tr: {
        cancel: 'İptal',
        image_capture: 'Görüntü Yakala',
      },
    },
  },
}
</script>

<style lang="scss">
.zoox-facial-biometry-modal {
  height: 100%;
  max-width: 400px;

  .video-container {
    height: 100%;
  }

  .zoox-card {
    max-width: 400px;
  }
}
</style>

<style lang="scss" scoped>
.card-actions {
  display: flex;
  justify-content: flex-end;
}
</style>
